import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import paths from './paths'
import { useMainStore } from '@/store';

const routes: Array<RouteRecordRaw> = [
  {
    path: paths.login,
    name: 'Login',
    component: () => import('../views/Login/Login.vue'),
  },
  {
    path: paths.password_recovery,
    name: 'PasswordRecovery',
    component: () => import('../views/PasswordRecovery/PasswordRecovery.vue'),
  },
  {
    alias: paths.register,
    path: `${paths.register}/:step?`,
    name: 'Register',
    component: () => import('../views/Register/Register.vue'),
  },
  {
    alias: '/:token?',
    path: `${paths.validator}/:token?`,
    name: 'Validator',
    component: () => import('../views/Validator/Validator.vue'),
  },
  {
    path: `${paths.prescription}/:id?`,
    name: 'Prescription',
    component: () => import('../views/Prescription/Prescription.vue'),
  },
  {
    path: paths.not_found,
    name: 'NotFound',
    component: () => import('../views/NotFound/NotFound.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: {
      name: 'NotFound'
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const store = useMainStore()
  const session = store.session
  if (to.meta.requiresAuth && !session) {
    next(paths.login);
  } else {
    next();
  }
});

export default router
